import React from 'react';

var TUXNavBarIconAction = function TUXNavBarIconAction(_ref) {
  var icon = _ref.icon,
      disabled = _ref.disabled,
      onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement("button", {
    className: "tux-nav-bar-icon-action h-40 w-40 p-0 text-color-TextPrimary flex items-center justify-center",
    disabled: disabled,
    onClick: onClick
  }, icon);
};

export { TUXNavBarIconAction };
//# sourceMappingURL=TUXNavBarIconAction.js.map
